import { gql } from '@apollo/client';

export const CURRICULUMS_QUERY = gql`
    query curriculums {
        curriculums(useSegmentationFilter: false) {
            edges {
                node {
                    id
                    tagIds
                    locales {
                        locale
                        name
                        description
                    }
                    thumbnailImage {
                        id
                        name
                        url
                        __typename
                    }
                    heroImage {
                        id
                        name
                        url
                        __typename
                    }
                    courses(useSegmentationFilter: false) {
                        edges {
                            node {
                                id
                                
                            }
                        }
                    }
                    brandIds
                    createdAt
                    updatedAt
                }
            }
        }
    }
`;
